/** @jsxImportSource @emotion/react */
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import { EmailTemplateTypeEnum } from '__generatedTypes__/globalTypes'
import { CommonEmail } from '../CommonEmail'

type Props = {
  platform: Platform
}

export const FreeMembershipActivation = ({ platform }: Props) => (
  <CommonEmail
    type={EmailTemplateTypeEnum.FreeActivation}
    platformId={platform.id}
    withDisableForAdmin
    withDisableForMember
  />
)
